import { NotFoundMessage } from '@hendrx/core/common/components/messages/PageMessage/Messages/NotFoundMessage';
import { TemplatesPage, useGetTemplatesPermissionsQuery } from '@hendrx/core/templates';
import { createFileRoute } from '@tanstack/react-router';

import { CustomLoadingOverlay } from 'shared/components/app/CustomLoadingOverlay';
import { useWorkspaceConfiguration } from 'shared/queries/workspaceConfiguration';

export const Route = createFileRoute('/studio/templates')({
  component: TemplatesPageWrapper
});

function TemplatesPageWrapper() {
  const { data: templatesPermissionsData, isLoading } = useGetTemplatesPermissionsQuery();
  const workspace = useWorkspaceConfiguration();

  if (isLoading || !workspace.isResolved) {
    return <CustomLoadingOverlay visible />;
  }

  // Templates are out of an external organization's authoring surface entirely (FR-026). Kept alongside the
  // existing `canManage` (which separates a CET admin from a CET teacher) rather than replacing it, and still
  // renders `NotFoundMessage` — never `/unauthorized`, which would log the user out. `constrainsContentTypes`
  // is the external-organization signal the rest of the authoring surface uses; see the note in
  // `common/utils/externalWorkspace.ts` on giving templates their own permitted flag if the axes ever diverge.
  const canManageTemplates = templatesPermissionsData?.canManage && !workspace.constrainsContentTypes;

  return canManageTemplates ? <TemplatesPage /> : <NotFoundMessage />;
}
